<template>
  <div class="card mg-t-20">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Тээврийн хэрэгсэл</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            vehicleCountData.params.mode = 1;
            loadVehicleCount();
          "
          :class="
            `nav-link ${vehicleCountData.params.mode == 1 ? 'active' : ''}`
          "
          role="button"
          >1D</a
        >
        <a
          @click="
            vehicleCountData.params.mode = 2;
            loadVehicleCount();
          "
          :class="
            `nav-link ${vehicleCountData.params.mode == 2 ? 'active' : ''}`
          "
          role="button"
          >1W</a
        >
        <a
          @click="
            vehicleCountData.params.mode = 3;
            loadVehicleCount();
          "
          :class="
            `nav-link ${vehicleCountData.params.mode == 3 ? 'active' : ''}`
          "
          role="button"
          >1M</a
        >
        <a
          @click="
            vehicleCountData.params.mode = 4;
            loadVehicleCount();
          "
          :class="
            `nav-link ${vehicleCountData.params.mode == 4 ? 'active' : ''}`
          "
          role="button"
          >1Y</a
        >
      </nav>
    </div>
    <div class="card-body" v-if="vehicleCountData.rdy">
      <div class="row mg-b-20">
        <div class="col text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{ vehicleCountData.data.allCount }}
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Давхардсан
          </p>
        </div>
        <div class="col  text-center">
          <h4 class="tx-normal tx-rubik tx-spacing--1 mg-b-10">
            {{ vehicleCountData.data.distinctedCount }}
          </h4>
          <p class="tx-11 tx-uppercase tx-spacing-1 tx-medium tx-color-03">
            Давхардаагүй
          </p>
        </div>
      </div>
      <div class="chart-three">
        <apexchart
          type="area"
          height="100"
          :options="chartOptionsSpark1"
          :series="seriesSpark1"
        ></apexchart>
        <div class="text-muted tx-12">Сүүлийн 10 хоног</div>
      </div>
      <!-- <ul class="list-group list-group-flush tx-13">
        <li class="list-group-item d-flex pd-sm-0">
          <div class="avatar d-xs-block d-sm-block mg-r-5">
            <span class="avatar-initial rounded-circle bg-info op-5"
              ><i class="icon ion-md-car"></i
            ></span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-2">
              {{ vehicleCountData.data.allCount }}
            </p>
            <small class="tx-12 tx-color-03 mg-b-0"
              >Тээврийн хэрэгсэл давхардсан тоогоор</small
            >
          </div>
        </li>
        <li class="list-group-item d-flex pd-sm-0 mg-t-5">
          <div class="avatar d-xs-block d-sm-block mg-r-5">
            <span class="avatar-initial rounded-circle bg-success op-5"
              ><i class="icon ion-md-car"></i
            ></span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-2">
              {{ vehicleCountData.data.distinctedCount }}
            </p>
            <small class="tx-12 tx-color-03 mg-b-0"
              >Тээврийн хэрэгсэл давхардалгүй тоогоор</small
            >
          </div>
        </li>
      </ul> -->
    </div>
    <div v-else class="pd-20">
      Боловсруулалт хийж байна...
    </div>
    <div class="card-footer tx-11 tx-color-03">
      <div>
        Хамрах хугацаа:
        {{ vehicleCountData.data.processed.startDate | moment("YYYY.MM.DD") }}
        -
        {{ vehicleCountData.data.processed.endDate | moment("YYYY.MM.DD")
        }}<br />
        Боловсруулсан:
        {{ vehicleCountData.data.processed.time.toFixed(2) }}сек
      </div>
    </div>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      vehicleCountData: {
        rdy: 0,
        params: {
          mode: 1,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          allCount: 0,
          distinctedCount: 0,
          processed: {
            time: 0,
            startDate: "2023-01-01",
            endDate: "2023-01-01",
          },
        },
      },
      chartKey: 0,
      seriesSpark1: [
        {
          name: "Зорчсон тээврийн хэрэгслийн тоо",
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54],
        },
      ],
      chartOptionsSpark1: {
        chart: {
          type: "area",
          height: 100,
          sparkline: {
            enabled: true,
          },
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          opacity: 0.3,
        },
        xaxis: {
          crosshairs: {
            width: 1,
          },
          type: "datetime",
          categories: [],
        },
        yaxis: {
          min: 0,
        },
        title: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "24px",
          },
        },
        subtitle: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "14px",
          },
        },
      },
    };
  },
  mounted() {
    this.loadVehicleCount();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loadVehicleCount() {
      this.vehicleCountData.rdy = false;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/VehicleCountByDate" },
        params: {
          mode: this.vehicleCountData.params.mode,
          startDate: this.vehicleCountData.params.startDate,
          endDate: this.vehicleCountData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        console.log(res, " res");
        if (res != false) {
          this.vehicleCountData.data = res.data;
          this.vehicleCountData.rdy = true;

          this.seriesSpark1[0].data = res.data.list.map((x) => x.count);
          this.chartOptionsSpark1.xaxis.categories = res.data.list.map(
            (x) => x.date
          );
          //this.vehicleCountData.processed = res.data.processed
        }
      });
    },
  },
};
</script>
